import {
  type ContractOverviewData,
  type ContractOverviewDataDTO,
  type ContractOverviewProduct,
  type ContractOverviewProductDTO,
  type UpdatedContractOverviewData,
} from "~/features/contracts/redux/types";

import * as ApiHelper from "~/common/utils/ApiHelper";
import { getDate } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export interface ContractsOverviewParams {
  materialNumber?: string;
  designation?: string;
  customerMaterialNumber?: string;
}

const apiUrl = resolveApiUrl("/my-account/searchContractsList");

export const fetchContractsOverview = (params?: ContractsOverviewParams) => {
  return fetch(apiUrl, {
    body: JSON.stringify(params || {}),
    method: "POST",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json() as Promise<UpdatedContractOverviewData[] | null>;
      }
      throw new Error(`Error fetching data! Code ${response.status} - ${response.statusText}`);
    })
    .then((data) => {
      if (!data) {
        return [];
      }
      return data;
    });
};

/** @deprecated */
export function getContractsOverview(params?: ContractsOverviewParams): Promise<ContractOverviewData[]> {
  return fetch(apiUrl, {
    body: JSON.stringify(params || {}),
    method: "POST",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json() as Promise<ContractOverviewDataDTO[] | null>;
      }
      throw new Error(`Error fetching data! Code ${response.status} - ${response.statusText}`);
    })
    .then(transform);
}

function transform(data: ContractOverviewDataDTO[] | null): ContractOverviewData[] {
  if (!data) {
    return [];
  }

  return data.map(transformSingleOverview);
}

function transformSingleOverview(data: ContractOverviewDataDTO): ContractOverviewData {
  return {
    price: data.price,
    isExpanded: data.isExpanded,
    contractNumber: data.salesDocument,
    customerContractNumber: data.customerOrderId,
    contractPeriodEnd: getDate(data.contractPeriodEnd),
    contractPeriodStart: getDate(data.contractPeriodStart),
    products: data.products.map(transformSingleProduct),
  };
}

function transformSingleProduct(data: ContractOverviewProductDTO): ContractOverviewProduct {
  return {
    productDetailsUrl: data.product.url,
    contractDetailsUrl: data.contractDetailsUrl,
    customerMaterialNumber: data.customerMaterial,
    sapMaterialNumber: data.product.sapMaterialNumber,
    designation: data.product.designation,
    packageCode: data.packCode,
    position: data.lineNumber,
  };
}
